module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2NCA2NCIgZW5hYmxlLWJhY2tncm91bmQ9Im5ldyAwIDAgNjQgNjQiPjxwYXRoIGQ9Ik0zMiwyQzE1LjQzMSwyLDIsMTUuNDMyLDIsMzJjMCwxNi41NjgsMTMuNDMyLDMwLDMwLDMwYzE2LjU2OCwwLDMwLTEzLjQzMiwzMC0zMEM2MiwxNS40MzIsNDguNTY4LDIsMzIsMnogTTI1LjAyNSw1MAoJbC0wLjAyLTAuMDJMMjQuOTg4LDUwTDExLDM1LjZsNy4wMjktNy4xNjRsNi45NzcsNy4xODRsMjEtMjEuNjE5TDUzLDIxLjE5OUwyNS4wMjUsNTB6IiBmaWxsPSIjMzZiMzdlIi8+PC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/green-check.svg
// module id = XNdA
// module chunks = 117